import React from 'react';
import { isMobile, browserName } from 'react-device-detect';

// import android from '../../assets/images/device/android.png';
import chrome from '../../assets/images/device/chrome.png';
import edge from '../../assets/images/device/edge.png';
import firefox from '../../assets/images/device/firefox.png';
import safari from '../../assets/images/device/safari.png';


export default class Ask extends React.PureComponent {
    
    renderChrome() {
        return <img src={chrome} alt={'chrome'} className='tutorial-image img-fluid'></img>;
    }
    
    renderEdge() {
        return <img src={edge} alt={'edge'} className='tutorial-image img-fluid'></img>;
    }
    
    renderFirefox() {
        return <img src={firefox} alt={'firefox'} className='tutorial-image img-fluid'></img>;
    }
    
    renderSafari() {
        return <img src={safari} alt={'safari'} className='tutorial-image img-fluid'></img>;
    }
        
    render() {

        return (
            <div style={{ textAlign: 'center' }}>
                <h3 className="hoco_title">N'oubliez pas de cliquer "accepter"</h3>
                <h4 className="hoco_subtitle">lorsque le navigateur vous fera la demande.</h4>
            </div>
        )
            
        if (isMobile)
            return ( 
                <React.Fragment>
            
                </React.Fragment>
            );
        return ( 
            <React.Fragment>
                { this['render' + browserName]() }
            </React.Fragment>
        );
    }
}
